/* BCB PDP Deferred Scripts v3 (17 Agu 2026)
 * Combines non-critical inline scripts into a single cacheable, deferred file.
 * Loaded with defer - runs after DOM parse, before DOMContentLoaded.
 * v2: Koala kaldirildi, wholesale CTA Fly Bundles (gfb*) widget'ina tasindi.
 * v3: PDP wholesale CTA KALDIRILDI (Tunahan karari 17 Agu 2026). Gerekce: mobilde
 *     SEPETE EKLE'nin hemen ustunde ikinci bir cikis kapisiydi ve ayni sayfaya giden
 *     ikinci bir link (theme-snippets/wholesale-cta.liquid) zaten asagida duruyor.
 *     Olcum: 3-16 Agu'da wholesale_cta_click 38, wholesale_page_view 1.980,
 *     wholesale_inquiry_submit 1. Geri almak icin yedek:
 *     LifeOS/03-Resources/BCB-Tema-Yedek/bcb-pdp-deferred.js.2026-08-17-oncesi.js
 */

(function() {
  'use strict';

  /* --- 1. FBT Gift Wrapping auto-uncheck (TODO-199) --- */
  function uncheckGiftWrap() {
    document.querySelectorAll('.cbb-frequently-bought-selector-input').forEach(function(cb) {
      if (cb.getAttribute('aria-label') && cb.getAttribute('aria-label').toLowerCase().indexOf('gift wrapping') !== -1 && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  var giftWrapTimer = setInterval(function() {
    if (document.querySelector('.cbb-frequently-bought-selector-input')) {
      clearInterval(giftWrapTimer);
      uncheckGiftWrap();
    }
  }, 300);
  setTimeout(function() { clearInterval(giftWrapTimer); }, 10000);

  /* --- 2. (kaldirildi 17 Agu 2026) PDP wholesale CTA --- */

  /* --- 3. Wholesale page GA4 tracking (28 Sub 2026) --- */
  if (location.pathname === '/pages/wholesale') {
    try {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ event: 'wholesale_page_view', event_category: 'engagement', page_path: '/pages/wholesale' });
    } catch (e) {}
    var form = document.querySelector('#ws-form form');
    if (form) {
      form.addEventListener('submit', function() {
        try {
          var type = document.getElementById('ws-type');
          var vol = document.getElementById('ws-volume');
          dataLayer.push({
            event: 'wholesale_inquiry_submit',
            event_category: 'lead',
            wholesale_business_type: type ? type.value : '',
            wholesale_volume: vol ? vol.value : ''
          });
        } catch (e) {}
      });
    }
  }

  /* --- 4. Shopify Chat (Inbox) delayed activation --- */
  /* Chat widget loads via content_for_header (can't prevent download).
   * This delays the visual appearance until user has been on page 5s or scrolls.
   * Saves ~256KB from blocking initial TTI calculation. */
  var chatRevealed = false;
  function revealChat() {
    if (chatRevealed) return;
    chatRevealed = true;
    var style = document.getElementById('bcb-chat-delay');
    if (style) style.remove();
  }
  // Reveal after 5 seconds or on first scroll/click
  setTimeout(revealChat, 5000);
  var revealEvents = ['scroll', 'click', 'touchstart'];
  revealEvents.forEach(function(evt) {
    window.addEventListener(evt, revealChat, { once: true, passive: true });
  });
})();
